import { z } from 'zod';
// Mirrors class-validator `@IsDateString()` (validator.js isISO8601, non-strict):
// accepts an ISO 8601 date ("2026-01-01") or date-time
// ("2026-01-01T10:00:00.000Z") string. Does NOT coerce to a Date — the value
// stays a string, exactly like the legacy decorator.
const ISO_8601_REGEX = /^\d{4}-\d{2}-\d{2}([T ]\d{2}:\d{2}(:\d{2}(\.\d{1,9})?)?(Z|[+-]\d{2}:?\d{2})?)?$/;
export const isoDateString = () => z.string().regex(ISO_8601_REGEX, 'must be a valid ISO 8601 date string');
